import * as PropTypes from 'prop-types';
import React, { useContext } from "react";
import { buyNowContext } from "../BuyNow";
import RangeSelector from "./RangeSelector";

const QuantitySelector = ({ quantityValue, onChange, minVal, maxVal, readOnly, buttonStyle, buttonClass, textStyle, textClass, containerStyle, containerClass, onMinBound, onMaxBound }) => {
  const { quantitiesEnabled } = useContext(buyNowContext);

  if (!quantitiesEnabled)
    return null;

  if (readOnly)
    return <div style={textStyle} className={textClass}>{quantityValue}</div>

  return (
    <RangeSelector
      value={quantityValue}
      minVal={minVal}
      maxVal={maxVal}
      onChange={newVal => onChange(newVal)}
      buttonStyle={buttonStyle}
      buttonClass={buttonClass}
      textStyle={textStyle}
      textClass={textClass}
      containerClass={containerClass}
      containerStyle={containerStyle}
      onMinBound={onMinBound}
      onMaxBound={onMaxBound}
    />
  );
};

QuantitySelector.propTypes = {
  readOnly: PropTypes.bool,
  buttonStyle: PropTypes.object,
  buttonClass: PropTypes.string,
  textStyle: PropTypes.object,
  textClass: PropTypes.string,
  containerStyle: PropTypes.object,
  containerClass: PropTypes.string,
  quantityValue: PropTypes.number.isRequired,
  minVal: PropTypes.number,
  maxVal: PropTypes.number,
  onChange: PropTypes.func,
  onMinBound: PropTypes.func,
  onMaxBound: PropTypes.func
};

QuantitySelector.defaultProps = {
  readOnly: false,
  buttonStyle: undefined,
  buttonClass: undefined,
  textStyle: undefined,
  textClass: undefined,
  containerStyle: undefined,
  containerClass: undefined,
  minVal: 1,
  maxVal: 100,
  onChange: () => { },
  onMinBound: () => { },
  onMaxBound: () => { }
};

export default QuantitySelector;
